// components/Boards/BoardPagination.jsx
// 페이지네이션 기능 – 페이지 전환 UI 담당

import { Box, Pagination, Button, useMediaQuery } from '@mui/material';
import { Link, useSearchParams } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

const BoardPagination = ({ currentPage, totalPages, onPageChange, canWrite = true }) => {
  const safePage = currentPage || 1;
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get('category');

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // ✅ 모바일 여부 판단

  const writeLink = `/main/posts/create${categoryId ? `?category=${categoryId}` : ''}`;

  return (
    <Box sx={{ mt: 4 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
        }}
      >
        {isMobile ? (
          // ✅ 모바일 전용 페이지네이션
          <Pagination
            size="small"
            siblingCount={0}
            boundaryCount={1}
            count={totalPages}
            page={safePage}
            onChange={(e, page) => onPageChange(page)}
            color="primary"
          />
        ) : (
          // ✅ PC용 페이지네이션
          <Pagination
            count={totalPages}
            page={safePage}
            onChange={(e, page) => onPageChange(page)}
            siblingCount={1}
            boundaryCount={1}
            color="primary"
            showFirstButton
            showLastButton
          />
        )}

        {/* ✅ 글쓰기 버튼 조건부 렌더링 */}
        {canWrite && (
          <Button
            variant="contained"
            component={Link}
            to={writeLink}
            sx={{ width: isMobile ? '100%' : 'auto' }}
          >
            게시글 작성
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default BoardPagination;